var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockoutDateCalendar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_37800_6103)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 1C3 0.447715 3.44772 0 4 0C4.55228 0 5 0.447715 5 1V1.5H7V1C7 0.447715 7.44772 0 8 0C8.55229 0 9 0.447715 9 1V1.5H11V1C11 0.447715 11.4477 0 12 0C12.5523 0 13 0.447715 13 1V1.5H14C15.1046 1.5 16 2.39543 16 3.5V14C16 15.1046 15.1046 16 14 16H2C0.895431 16 0 15.1046 0 14V3.5C0 2.39543 0.895431 1.5 2 1.5H3V1ZM6.27641 7.37501V6.8125C6.27641 5.72519 6.89564 5 8.00021 5C9.10478 5 9.75972 5.72519 9.75972 6.8125V7.37501H6.27641ZM5.14307 7.37501V6.8125C5.14307 5.2592 6.42225 4 8.00021 4C9.57817 4 10.8574 5.2592 10.8574 6.8125V7.37501H11C11.5523 7.37501 12 7.82272 12 8.37501V12C12 12.5523 11.5523 13 11 13H5C4.44772 13 4 12.5523 4 12V8.37501C4 7.82272 4.44772 7.37501 5 7.37501H5.14307ZM9.14265 10.1875C9.14265 10.8088 8.63097 11.3125 7.99979 11.3125C7.36861 11.3125 6.85693 10.8088 6.85693 10.1875C6.85693 9.56618 7.36861 9.0625 7.99979 9.0625C8.63097 9.0625 9.14265 9.56618 9.14265 10.1875Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_37800_6103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockoutDateCalendar);
export default __webpack_public_path__ + "static/media/lockoutDateCalendar.83a997c1.svg";
export { ForwardRef as ReactComponent };